import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface VerticalViewStylesClasses {
  itemTitle: string;
}

const useVerticalViewStyles = makeStyles<Theme>((theme) => ({
  itemTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export type { VerticalViewStylesClasses };
export default useVerticalViewStyles;
